export interface RevenuePoint {
  label: string;
  value: number;
}

export interface RevenueSummary {
  direct: number;
  packages: number;
  deliveryFees: number;
  total: number;
  chart: RevenuePoint[];
}

export const revenueByPeriod: { today: RevenueSummary; week: RevenueSummary; month: RevenueSummary } = {
  today: {
    direct: 2850,
    packages: 640,
    deliveryFees: 180,
    total: 3670,
    chart: [
      { label: '9 ص', value: 420 },
      { label: '11 ص', value: 610 },
      { label: '1 م', value: 540 },
      { label: '3 م', value: 730 },
      { label: '5 م', value: 680 },
      { label: '7 م', value: 690 },
    ],
  },
  week: {
    direct: 18450,
    packages: 5120,
    deliveryFees: 1240,
    total: 24810,
    chart: [
      { label: 'الأحد', value: 3120 },
      { label: 'الإثنين', value: 3560 },
      { label: 'الثلاثاء', value: 2980 },
      { label: 'الأربعاء', value: 4210 },
      { label: 'الخميس', value: 4890 },
      { label: 'الجمعة', value: 3240 },
      { label: 'السبت', value: 2810 },
    ],
  },
  month: {
    direct: 76200,
    packages: 21400,
    deliveryFees: 4980,
    total: 102580,
    chart: [
      { label: 'أسبوع 1', value: 21400 },
      { label: 'أسبوع 2', value: 24800 },
      { label: 'أسبوع 3', value: 27650 },
      { label: 'أسبوع 4', value: 28730 },
    ],
  },
};

export const commissionRate = 12;

export const orderCommissions = [
  { orderNo: '#98756', date: '2026-09-16', amount: 185, rate: 12, deducted: 22.2, transferred: 15, net: 162.8 },
  { orderNo: '#98755', date: '2026-09-16', amount: 140, rate: 12, deducted: 16.8, transferred: 18, net: 141.2 },
  { orderNo: '#98754', date: '2026-09-16', amount: 210, rate: 12, deducted: 25.2, transferred: 15, net: 199.8 },
  { orderNo: '#98747', date: '2026-09-16', amount: 195, rate: 12, deducted: 23.4, transferred: 15, net: 186.6 },
  { orderNo: '#98744', date: '2026-09-16', amount: 240, rate: 12, deducted: 28.8, transferred: 0, net: 211.2 },
  { orderNo: '#98733', date: '2026-09-16', amount: 320, rate: 12, deducted: 38.4, transferred: 20, net: 301.6 },
  { orderNo: '#98711', date: '2026-09-15', amount: 205, rate: 12, deducted: 24.6, transferred: 20, net: 185.4 },
  { orderNo: '#98699', date: '2026-09-15', amount: 148, rate: 12, deducted: 17.76, transferred: 13, net: 143.24 },
  { orderNo: '#98691', date: '2026-09-15', amount: 190, rate: 12, deducted: 22.8, transferred: 14, net: 181.2 },
  { orderNo: '#98682', date: '2026-09-14', amount: 96, rate: 12, deducted: 11.52, transferred: 16, net: 100.48 },
];

export const packageCommissions = [
  { name: 'باقة الأساس (20 قطعة)', customer: 'عبدالله الشمري', date: '2026-09-16', amount: 400, rate: 12, net: 352 },
  { name: 'باقة العائلة (50 قطعة)', customer: 'خالد الغامدي', date: '2026-09-15', amount: 850, rate: 12, net: 748 },
  { name: 'باقة العناية (80 قطعة)', customer: 'ناصر الحربي', date: '2026-09-15', amount: 1250, rate: 12, net: 1100 },
  { name: 'باقة الأساس (20 قطعة)', customer: 'غادة المالكي', date: '2026-09-13', amount: 400, rate: 12, net: 352 },
  { name: 'باقة العائلة (50 قطعة)', customer: 'هند المطيري', date: '2026-09-12', amount: 850, rate: 12, net: 748 },
];

export const settlementDues = 8420;

export const settlementsHistory = [
  { id: 'ST-1042', requestDate: '2026-09-10', processDate: '2026-09-12', amount: 6200, status: 'transferred', note: '' },
  { id: 'ST-1036', requestDate: '2026-09-02', processDate: '2026-09-04', amount: 5180, status: 'transferred', note: '' },
  { id: 'ST-1031', requestDate: '2026-08-25', processDate: '2026-08-27', amount: 4300, status: 'rejected', note: 'عدم اكتمال بيانات الحساب البنكي' },
  { id: 'ST-1020', requestDate: '2026-08-15', processDate: '2026-08-17', amount: 3950, status: 'transferred', note: '' },
];